module.exports = __webpack_public_path__ + "img/greenwich-g-series-rectangle-top-angle.41bc0cdd.png";